module.exports = __webpack_public_path__ + "static/media/Housefilter.599c0c10.svg";